import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import MenuDrawer from '../components/MenuDrawer'
import { pushLocation } from '../../../store/location'
import { toggleMenu, toggleProfile } from '../../../store/global'

const mapStateToProps = state => ({
  ...state.authentication,
  ...state.global
})

const mapDispatchToProps = (dispatch, { docked }) => ({
  goHomepage() {
    manipulateLayout(dispatch, docked, '/')
  },
  goMeetingRoomBooking() {
    manipulateLayout(dispatch, docked, '/meeting-room-booking')
  },
  goMeetingRoomBackend() {
    manipulateLayout(dispatch, docked, '/admin/meeting-room-booking')
  },
  goStationeryBooking() {
    manipulateLayout(dispatch, docked, '/stationery-booking/s/')
  },
  goLeaveRequest() {
    manipulateLayout(dispatch, docked, '/leave-request/l')
  },
  goMyColleagues() {
    manipulateLayout(dispatch, docked, '/my-colleagues')
  },
  goStaffsCalendar() {
    manipulateLayout(dispatch, docked, '/staffs-calendar')
  },
  goLeaveRequestManager() {
    manipulateLayout(dispatch, docked, '/leave-request/manager')
  },
  goLeaveRequestStaff() {
    manipulateLayout(dispatch, docked, '/leave-request/staff-list')
  },
  goPayslips() {
    manipulateLayout(dispatch, docked, '/payslips')
  },
  goHelp() {
    manipulateLayout(dispatch, docked, '/help')
  },
  goStationeryType() {
    manipulateLayout(dispatch, docked, '/admin/stationery-type')
  },
  goStationeryBackend() {
    manipulateLayout(dispatch, docked, '/admin/stationery')
  },
  goStationeryDeliveryBackend() {
    manipulateLayout(dispatch, docked, '/admin/stationery-delivery')
  },

  goAdminTools() {
    manipulateLayout(dispatch, docked, '/admin-tools')
  },
  goArticleManager() {
    manipulateLayout(dispatch, docked, '/news-article/list')
  },
  goCategoryManager() {
    manipulateLayout(dispatch, docked, `/news-category/list`)
  }
})

function manipulateLayout(dispatch, docked, url) {
  dispatch(pushLocation(url))
  dispatch(toggleProfile(false))
  !docked && dispatch(toggleMenu(false))
}

const MenuDrawerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuDrawer)

export default withRouter(MenuDrawerContainer)



// WEBPACK FOOTER //
// ./src/layouts/Authenticated/containers/MenuDrawer.js